module.exports = __webpack_public_path__ + "./font/Raleway.woff2";


/*****************
 ** WEBPACK FOOTER
 ** ./docs/src/fonts/Raleway.woff2
 ** module id = 214
 ** module chunks = 0
 **/